export const addIdToGalleryImages = (
  galleryImages: any,
  category: string,
  startIdNumber: number = 1,
) => {
  return galleryImages.map((galleryItem: any, index: number) => ({
    id: `${category}-${index + startIdNumber}`,
    url: galleryItem.url,
  }));
};
